<template>
    <ACP-Layout>
    </ACP-Layout>
</template>

<script>
    import ACPLayout from '@/Layouts/ACP'

    export default {
        components: {
            ACPLayout,
        },
    }
</script>
